import type { Agency } from '@/modules/agencies/types/agency'
import { formatAgencyDate } from '@/modules/agencies/utils/formatAgencyDate'

export type AgencyDetailOverviewProps = {
  agency: Agency
}

type DetailRow = {
  label: string
  value: string
  mono?: boolean
}

export function AgencyDetailOverview({ agency }: AgencyDetailOverviewProps) {
  const rows: DetailRow[] = [
    { label: 'Agency ID', value: agency.id, mono: true },
    { label: 'Name', value: agency.name },
    { label: 'Slug', value: agency.slug, mono: true },
    { label: 'Status', value: agency.status },
    { label: 'Created by', value: agency.createdBy, mono: true },
    { label: 'Created', value: formatAgencyDate(agency.createdAt) },
    { label: 'Updated', value: formatAgencyDate(agency.updatedAt) },
  ]

  return (
    <div className="border-2 border-ink bg-surface">
      <div className="border-b-2 border-ink bg-paper px-4 py-3">
        <h2 className="font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
          Overview
        </h2>
      </div>
      <dl className="divide-y divide-line">
        {rows.map((row) => (
          <div
            key={row.label}
            className="grid gap-1 px-4 py-3 sm:grid-cols-[10rem_1fr] sm:items-center"
          >
            <dt className="font-mono text-[0.68rem] uppercase tracking-[0.1em] text-muted">
              {row.label}
            </dt>
            <dd
              className={
                row.mono
                  ? 'break-all font-mono text-sm text-ink'
                  : 'text-sm font-semibold text-ink'
              }
            >
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
